import VForm from '@/vuetify_custom/v-form'
import { VCard, VCardTitle, VCardText } from 'vuetify/lib'
import { commonValidateRule } from './utils'
import { common_mixins } from './EditMixIns.jsx'
import styles from './index.module.less'
const commonValidateRuleGo = commonValidateRule('必选')
const commonValidateRuleGG = commonValidateRule('必填')
export default {
    mixins:[common_mixins],
    computed: {
        fields() {
       
            return [
                {
                    label: '充值类型',
                    type:'select_field_v1',
                    key:'recharge_type',
                    required: true,
                    items: [
                        {
                            title: '推广平台账号',
                            key: 'ad_account'
                        },
                        {
                            title: '店铺平台',
                            key: 'online_store'
                        },
                        {
                            title: '第三方合作平台（如京东、携程等）',
                            key: 'other'
                        }
                    ],
                    cols:3,
                    rules: [commonValidateRuleGo]
                },
                {
                    type:'empty',
                    cols:9,
                },
                // {
                //     label: '账号/店铺信息',
                //     cols:3,
                //     required: true,
                //     rules: [commonValidateRuleGo]
                // },
                {
                    label: '充值金额',
                    type: 'number_field',
                    key: 'recharge_amount',
                    cols:2,
                    required: true,
                    rules: [commonValidateRuleGG]
                },
                {
                    label: '消耗方式',
                    cols:3,
                    type:'select_field_v1',
                    key: 'consumption_mode',
                    items: [
                        {
                            title: '一次性消耗',
                            key: 'one_time'
                        },
                        {
                            title: '不定期消耗',
                            key: 'multiple'
                        },
                        {
                            title: '定期按月消耗',
                            key: 'monthly'
                        }
                    ],
                    required: true,
                    rules: [commonValidateRuleGo]
                },
                {
                    label: '余额是是否可退',
                    cols:4,
                    type: 'radio_buttons',
                    key: 'refundable',
                    row: true,
                    items: [
                        {
                            value: true,
                            key: true,
                            label: '是',
                        },
                        {
                            value: false,
                            key: false,
                            label: '否',
                        }
                    ]
                },

               
             ]
        }
    },
    methods: {
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                充值信息
            </VCardTitle>
            <VCardText>
            <VForm
            ref="base"
            fields={_this.fields}
            v-model={_this.params.expense_group_recharge}
        />
            </VCardText>
        </VCard>
    </div>
    }
}